import { render, staticRenderFns } from "./CardPlaceInfo.vue?vue&type=template&id=5a0d9d54&scoped=true&"
import script from "./CardPlaceInfo.vue?vue&type=script&lang=js&"
export * from "./CardPlaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardPlaceInfo.vue?vue&type=style&index=0&id=5a0d9d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d9d54",
  null
  
)

export default component.exports